import { createFileRoute, notFound } from '@tanstack/react-router'

import { BatchOperationsUploadModal } from '@/batch-operations/components/BatchOperationsUploadModal/BatchOperationsUploadModal'
import { FEATURE_USER_MANAGEMENT } from '@/core/constants/features'

export const Route = createFileRoute(
  '/company/_management/batch-operations/upload',
)({
  beforeLoad: ({ context: { user } }) => {
    if (!user?.features.includes(FEATURE_USER_MANAGEMENT)) {
      throw notFound()
    }
  },
  component: Upload,
})

function Upload() {
  const navigate = Route.useNavigate()
  return (
    <BatchOperationsUploadModal
      isOpen
      onClose={() => {
        navigate({ to: '/company/batch-operations' })
      }}
    />
  )
}
